export type Planet = {
  id: string;
  name: string;
  eyebrow: string;
  pulseQuery: string;
  temporal: "past" | "present" | "future";
  position: [number, number, number];
  radius: number;
  colorA: string;
  colorB: string;
  atmosphere: string;
  seed: number;
  ring?: boolean;
  habitable?: boolean;
};

export const PLANETS: Planet[] = [
  {
    id: "archive",
    name: "THE ARCHIVE",
    eyebrow: "PAST / LINEAGE",
    pulseQuery: "Unlabeled 90s vocal architecture returns as the hook layer on trap-low pop",
    temporal: "past",
    position: [0, 2.4, 13],
    radius: 2.35,
    colorA: "#151718",
    colorB: "#8a5d36",
    atmosphere: "#d8a36a",
    seed: 1.7,
    ring: true,
  },
  {
    id: "pulse",
    name: "THE PULSE",
    eyebrow: "PRESENT / LIVED CULTURE",
    pulseQuery: "After 2am, US rooms lock 112–118 BPM log-drum as the night default",
    temporal: "present",
    position: [12.36, 0.15, 4.01],
    radius: 3.05,
    colorA: "#061b1c",
    colorB: "#427d68",
    atmosphere: "#70e6d4",
    seed: 4.2,
    habitable: true,
  },
  {
    id: "horizon",
    name: "THE HORIZON",
    eyebrow: "FUTURE / POSSIBILITY",
    pulseQuery: "By 2031, club mixes are authored in stems, then crushed to stereo for phones",
    temporal: "future",
    position: [7.64, 1.9, -10.52],
    radius: 2.65,
    colorA: "#1a111d",
    colorB: "#6b3d68",
    atmosphere: "#d48cff",
    seed: 8.4,
    ring: true,
  },
  {
    id: "commons",
    name: "THE COMMONS",
    eyebrow: "SHARED / COLLABORATIVE",
    pulseQuery: "Lagos percussion packs outpace label promos as the booth source in UK rooms",
    temporal: "present",
    position: [-7.64, -2.1, -10.52],
    radius: 1.65,
    colorA: "#07191b",
    colorB: "#2f7278",
    atmosphere: "#7df9ff",
    seed: 12.1,
    habitable: true,
  },
  {
    id: "liminal",
    name: "THE LIMINAL",
    eyebrow: "EMERGING / UNRESOLVED",
    pulseQuery: "Uncredited night recordings become A&R input before any DSP page exists",
    temporal: "future",
    position: [-12.36, -1.4, 4.01],
    radius: 1.9,
    colorA: "#120e16",
    colorB: "#4c465f",
    atmosphere: "#8d91ff",
    seed: 15.8,
  },
];

export const PLANET_LINKS: [string, string][] = [
  ["archive", "pulse"],
  ["pulse", "horizon"],
  ["pulse", "commons"],
  ["commons", "liminal"],
  ["liminal", "horizon"],
];

export const FORECAST_TO_PLANET: Record<string, string> = {
  "catalog-hook-layer": "archive",
  "reissue-as-stems": "archive",
  "chant-808-hybrid": "archive",
  "logdrum-afterhours": "pulse",
  "detroit-kick-export": "pulse",
  "joburg-to-us-bounce": "pulse",
  "phone-collapse-mix": "horizon",
  "stem-default-berlin": "horizon",
  "club-exclusive-lowend": "horizon",
  "lagos-pack-booth": "commons",
  "whatsapp-aar": "liminal",
  "seoul-chop-leak": "liminal",
  "london-pirate-channel": "liminal",
};
